<template>
  <div id="projectPubC">
    <div class="colspan">
      <div class="top clearfix">
        <i></i>
        <p class="p1 clearfix">
          <i class="el-icon-s-order"></i> {{title}}
        </p>
        <p class="p2">
          <span> <em @click="getProjectListByValueTime('begin_time')"   >按时间</em>   <i  @click="getProjectListByValueTime('begin_time','asc')" class="el-icon-arrow-up"></i>  <i @click="getProjectListByValueTime('begin_time','desc')" class="el-icon-arrow-down">  </i> </span>
          <span> <em @click="getProjectListByValueMoney('donation_sum')" >按筹款金额</em>  <i @click="getProjectListByValueMoney('donation_sum','asc')"  class="el-icon-arrow-up"></i>  <i @click="getProjectListByValueMoney('donation_sum','desc')"  class="el-icon-arrow-down">  </i> </span>
        </p>
      </div>
      <div class="content">
        <ul>
          <li class="list" v-for="(item,index) in projectList" :key="index"  @click="goto(item.id)" >
              <router-link to="" >
                  <img v-lazy="item.cover_photo_text.url" alt="">
                  <p :title="item.name"> <span :class="item.if_donation== 2 ? 'over' : '' ">{{item.if_donation==1?'筹款中':'筹款结束'}}</span> {{item.name}}</p>
              </router-link>
              <div>
                <p>
                  <span>已筹到</span>
                  <span class="money"> ￥{{Number(item.donation_sum)>10000 ? (Number(item.donation_sum)/10000).toFixed(2)+'万':item.donation_sum }}</span>
                </p>
                <p>
                  <span>爱心人次</span>
                  <span class="number">{{item.donation_count}}</span>
                </p>
              </div>
          </li>
        </ul>
      </div>
      <div class="page">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="total"
           :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      projectList: [],
      timeSort:'',
      moneySort:'',
      describe:'',
      title:'',
      page: 1,
      page_size: 9,
      total: 0,
      cate_id: null,
      id: null, //导航id
      second_navId:null,//二级导航
    };
  },
  methods: {
    goto(id) {
      if(this.second_navId){
        this.$router.push({ name: "projectDetail", query: { type: 1,second_navId:this.second_navId,projectInfoId:id } });
      }else{
        this.$router.push({ name: "projectDetail", query: { type: 1 ,projectInfoId:id} });
      }
     
    },
    prev() {
      
    },

    //点击下一页和点击页码时执行
    handleCurrentChange(val) {
      this.getPageData();
    },
    //获取分页数据totalDataNumber
    // getPageData: function () {
    //     let that = this;
    //     // that.$db.post(this.$url.document.list,params).then(res=>{
    //     //     that.infoList = res.data.data
    //     //     that.total    = res.data.total
    //     // })
    // }.
    getProjectListByValueTime(order_by,order){
     
       if(!order){
          order = (this.timeSort == 'asc')?'desc':'asc' 
          this.timeSort = order
       }else{
          this.timeSort = order
       }
      
      this.getProjectListByValue(order_by,order)
    },
    getProjectListByValueMoney(order_by,order){
    
       if(!order){
          order = (this.moneySort == 'asc')?'desc':'asc' 
          this.moneySort = order
       }else{
         this.moneySort = order
       }
     
      this.getProjectListByValue(order_by,order)
    },
    getProjectListByValue(order_by,order){
      this.page = 1
      let that = this;
      let cate_id = ""
      if(this.cate_id){
        cate_id = "&cate_id="+this.cate_id
      }
      this.$db
        .get(
          this.$url.project.list +
            "?page=" +
            this.page +
            "&page_size=" +
            this.page_size+cate_id+"&order_by="+order_by+"&order="+order  
        )
        .then(res => {
          that.projectList = res.data.data;
        
          that.total = res.data.total;
        }).catch(err => {
            console.log(err);
          });

    },
    getPageData() {
      let that = this;
      let cate_id = ""
      if(this.cate_id){
        cate_id = "&cate_id="+this.cate_id
      }
      this.$db
        .get(
          this.$url.project.list +
            "?page=" +
            this.page +
            "&page_size=" +
            this.page_size+cate_id
        )
        .then(res => {
          that.projectList = res.data.data;
          that.total = res.data.total;
        }).catch(err => {
            console.log(err);
          });
        
    },
    getCateName(){
      this.$db.get(this.$url.project.info+'/'+this.cate_id).then(res=>{
           this.title = res.data.name     
        }).catch(err => {
            console.log(err);
          });
    }
   
  },
  created() {
    this.cate_id = this.$route.query.cate_id;
    if(!this.cate_id) this.title   = '项目列表'
    this.getPageData();
  },
  watch:{
        '$route.query.cate_id':function(value) {
            if(value){
              this.cate_id = value
              this.page = 1
              this.getCateName()
              this.getPageData()
            }else if(typeof(value)=='undefined'){
              this.title ='项目列表'
              this.cate_id = ''
              this.getPageData()
            }  
        },
        
      
    }
};
</script>
<style lang="less" scoped>
.colspan {
  // float: left;
  width: 950px;
  // min-height: 500px;
  overflow: hidden;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
  box-sizing: border-box;
  position: relative;
  > .top {
    padding: 0 30px;
    > i {
      width: 104px;
      height: 2px;
      position: absolute;
      left: 30px;
      top: 0;
    }
    > .p1 {
      // float: left;
      font-size: 20px;
      margin-bottom: 0;
    }
    > .p2 {
      position: absolute;
      top: 0;
      right: 30px;
      font-size: 18px;
      color: #404040;
      
      > span {
        display: inline-block;
        width: 120px;
        > em {
          font-style: normal
        }
        > i {
          position: absolute;
          cursor: pointer;
          margin-top: 10px;
          margin-left: 10px;
        }
        > i:nth-of-type(1){
          top: -10px;
        }
      }
    }
  }
  > .content {
    min-height: 500px;
    padding: 0 30px;
    > ul {
      list-style-type: none;
      padding: 0;
      margin-top: 46px;
      width: 100%;
      overflow: hidden;
      .list {
        width: 31%;
        height: 325px;
        float: left;
        margin-right: 30px;
        overflow: hidden;
        box-sizing: border-box;
        border: 1px solid #ccc;
        margin-bottom: 30px;
        a {
            text-decoration:none;
            margin: 0;
            padding: 0;
            > img {
              height: 60%;
              width: 100%;
              height: 202px;
            }
            > p{
            width: 100%;
            height: 50px;
            background-color: #fff;
            margin: 0;
            padding: 0 10px;
            font-size: 18px;
            line-height: 50px;
            margin-top: -10px;
            border-bottom: 1px dashed #ccc;
            font-size: 18px;
            color: #404040;
            box-sizing: border-box;
            overflow: hidden;    
            text-overflow: ellipsis;      //超出部分以省略号显示
            white-space: nowrap;
            > span {
              display: inline-block;
              height: 20px;
              background-color: #fff;
              border-radius: 4px;
              border: solid 1px #52a41e;
              text-align: center;
              line-height: 20px;
              font-size: 14px;
              color: #52a41e;
              padding: 2px;
            }
            > .over {
              background-color: #e5e5e5;
              color: #888;
              border: solid 1px #e5e5e5;
            } 
          }
        }
        > div {
          padding: 0 10px;
          height: 84px;
          > p {
            float: left;
            width: 50%;
            box-sizing: border-box;
            
            > span {
              display: inline-block;
              width: 100%;
              color: #888;
              font-size: 14px;
            }
            > .money {
              color: #ff3333;
              font-size: 20px;
              overflow: hidden;    
              text-overflow: ellipsis;      //超出部分以省略号显示
              white-space: nowrap;
            }
            > .number {
              color: #404040;
              font-size: 20px;
            }
          }
          > p:nth-of-type(1){
            border-right: 1px dashed #ccc;
          }
          > p:nth-of-type(2){
            padding-left: 16px;
          }
        } 
      }
      .list:nth-of-type(3n+0){
        margin-right: 0;
      }
    }
  }
  > .page {
    float: left;
    overflow: hidden;
    margin-left: 50%;
    margin-top: 20px;
    height: 100px;
    line-height: 100px;
    transform: translateX(-50%);
  }
  .page /deep/ .active {
      background-color: #d72324 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/project/pubContent.vue